/**
 * Get Sportnect nav to menu
 *
 * @param {Object} props
 * @param {Object} config
 * @return {Object}
 */
export const sportnectNavDropdownsResponsive = (t, config) => (
  {
    create: [
      {
        heading: t('presentProject'),
        name: t('createEvent'),
        href: '/admin/events/create',
        icon: 'sn-event',
        additionalIcon: 'sn-circle-plus',
      },
      {
        name: t('createClubAndGroup'),
        href: '/admin/clubs/create',
        icon: 'sn-group',
        additionalIcon: 'sn-circle-plus',
      },
      {
        name: t('createSportVenue'),
        href: '/admin/sport-venues/create',
        icon: 'sn-sportfield',
        additionalIcon: 'sn-circle-plus',
      },
    ],
    menu: [
      {
        heading: t('forOrganisers'),
        name: t('eventsManagement'),
        href: '/admin/events',
        icon: 'sn-event',
        additionalIcon: 'sn-manage',
      },
      {
        name: t('clubsAndGroupsManagement'),
        href: '/admin/clubs',
        icon: 'sn-group',
        additionalIcon: 'sn-manage',
      },
      {
        name: t('hotnewsManagement'),
        href: '/admin/posts',
        icon: 'sn-hotnews',
        additionalIcon: 'sn-manage',
      },
      {
        name: t('sportVenuesManagement'),
        href: '/admin/sport-venues',
        icon: 'sn-sportfield',
        additionalIcon: 'sn-manage',
      },
      {
        name: t('tournamentsManagement'),
        href: 'https://tournaments.sportnect.com',
        reactLink: false,
        target: '_blank',
        icon: 'sn-cup',
        additionalIcon: 'sn-manage',
      },
      {
        heading: t('me'),
        // name: t('sportnections'),
        name: t('community.title'),
        // href: '/sportnections',
        href: '/community',
        icon: 'sn-logo-sn',
        additionalIcon: 'sn-avatar',
      },
      {
        name: t('personalSettings'),
        href: '/admin/me',
        icon: 'sn-manage',
        additionalIcon: 'sn-avatar',
      },
      {
        name: t('timeline.posts'),
        href: '/',
        reactLink: false,
        target: '_self',
        icon: 'sn-bars',
      },
      {
        name: t('timeline.menu.events'),
        href: '/timeline-events?search=me---attending___cheers___invited___organized',
        reactLink: false,
        target: '_self',
        icon: 'sn-event',
      },
      {
        name: t('timeline.menu.clubs'),
        href: '/timeline-groups?search=me---attending___cheers___invited___organized',
        reactLink: false,
        target: '_self',
        icon: 'sn-group',
      },
    ],
    cities: [
      {
        heading: t('cityPortals'),
        name: t('projectCityOstravaName'),
        href: config.REACT_APP_CITY_OSTRAVA_URL,
        reactLink: false,
        target: '_blank',
        icon: 'circle-ostrava',
      },
      {
        name: t('projectCityOlomoucName'),
        href: config.REACT_APP_CITY_OLOMOUC_URL,
        reactLink: false,
        target: '_blank',
        icon: 'circle-olomouc',
      },
      {
        name: t('projectCityChebName'),
        href: config.REACT_APP_CITY_CHEB_URL,
        reactLink: false,
        target: '_blank',
        icon: 'circle-cheb',
      },
    ],
    family: [
      {
        heading: t('familyControlBox.title'),
        name: t('familyRelationshipsRegisterButtonText'),
        href: '/admin/me/family/register-child',
        icon: 'sn-substitute',
        additionalIcon: 'sn-substitute',
      },
      {
        name: t('familyRelationshipsSearchButtonText'),
        href: '/admin/me/family/propose-relationship',
        icon: 'sn-family',
        additionalIcon: 'sn-family',
      },
    ],
    landing: [
      {
        name: t('register'),
        href: '/signup',
        icon: 'sn-substitute',
        reactLink: true,
      },
    ],
  }
)
